import { render, staticRenderFns } from "./vehiclesTypes.vue?vue&type=template&id=d312c45c"
import script from "./vehiclesTypes.vue?vue&type=script&lang=js"
export * from "./vehiclesTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports